import { useTranslation } from 'react-i18next'
import { TOTAL_WIZARD_STEPS } from './onboardingSteps'

interface WizardStepHeaderProps {
  /** 1-based current step number across the whole onboarding journey. */
  step: number
  /** Localized step title. */
  title: string
  /** Total number of steps (defaults to the shared TOTAL_WIZARD_STEPS). */
  total?: number
}

/**
 * Shared header for every onboarding-wizard step: a numbered badge, the step
 * title, an "Étape N sur X" progress label and a thin progress bar. Replaces the
 * bare circular number that used to be duplicated across each step panel.
 */
export function WizardStepHeader({ step, title, total = TOTAL_WIZARD_STEPS }: WizardStepHeaderProps) {
  const { t } = useTranslation('assets')
  const pct = Math.min(100, Math.max(0, Math.round((step / total) * 100)))

  return (
    <div className="mb-6" data-testid="wizard-step-indicator">
      <div className="flex items-center gap-3 mb-2">
        <div className="w-8 h-8 bg-primary text-primary-foreground rounded-full flex items-center justify-center text-sm font-medium shrink-0">
          {step}
        </div>
        <div className="flex flex-col">
          <h2 className="text-xl font-semibold leading-tight">{title}</h2>
          <span className="text-xs text-muted-foreground" data-testid="wizard-step-progress">
            {t('create_building.step_progress', { current: step, total })}
          </span>
        </div>
      </div>
      <div className="h-1 w-full rounded-full bg-muted overflow-hidden" aria-hidden="true">
        <div className="h-full bg-primary transition-all" style={{ width: `${pct}%` }} />
      </div>
    </div>
  )
}
